import { Tooltip, TooltipProps } from '@redis-ui/components';
import { CSSProperties, ReactNode } from 'react';
import * as S from './EllipsisTooltipTableCell.style';
import useIsTextOverflows from '../../hooks/useIsTextOverflows';

interface EllipsisTooltipTableCellProps extends TooltipProps {
  style?: CSSProperties;
  className?: string;
  rows?: number;
  tooltipContent?: ReactNode;
}

const EllipsisTooltipTableCell = ({
  children,
  style,
  className,
  rows = 1,
  tooltipContent,
  ...rest
}: EllipsisTooltipTableCellProps) => {
  const { isTextOverFlows, cellRef } = useIsTextOverflows();

  return (
    <Tooltip disabled={!isTextOverFlows} content={tooltipContent} {...rest}>
      <S.Cell ref={cellRef} style={style} className={className} $rows={rows}>
        {children}
      </S.Cell>
    </Tooltip>
  );
};

export default EllipsisTooltipTableCell;
